<style scoped>
    .expand-row{
    }
	.ivu-table-expanded-cell{
		padding: 12px 8px;
	}
</style>
<template>
    <div style="padding: 0px;">
        <Row class="expand-row" style="text-align: center;">
			<Col span="3">
				<span class="expand-key">序号</span>
			</Col>
            <Col span="6">
                <span class="expand-key">地点</span>
            </Col>
            <Col span="5">
                <span class="expand-key">消费类型</span>
            </Col>
            <Col span="3">
                <span class="expand-key">金额</span>
            </Col>
			<Col span="5">
				<span class="expand-key">时间</span>
			</Col>
			<Col span="2">
				<span class="expand-key">状态</span>
			</Col>
        </Row>
        <Row v-for="(item,index) in datas" :key="index" style="text-align: center;">
			<Col span="3">
				<span class="expand-key">{{index+1}}</span>
			</Col>
            <Col span="6">
            	<span class="expand-value">卫计局食堂</span>
            </Col>
            <Col span="5">
            	<span class="expand-value">刷卡计次</span>
            </Col>
            <Col span="3">
            	<span class="expand-value">{{item.cmoney}}元</span>
            </Col>
            <Col span="5">
            	<span class="expand-value"><DateTime type="hm" :stime="item.ccreatetime"></DateTime></span>
            </Col>
            <Col span="2">
            	<span class="expand-value">{{item.cstatus=='00'?'成功':'失败'}}</span>
            </Col>
        </Row>
    </div>
</template>
<script>
	import datetimeshow from '../Meeting/Attend/expend-datetimeshow.vue';
    export default {
		components: {
			'DateTime': datetimeshow
		},
        props: {
            datas: Array
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Eatery/table-expand.vue